import { _findBy, noop } from "neetocist";
import { Dropdown, Spinner } from "neetoui";
import PropTypes from "prop-types";

import Menu from "./Menu";
import "./status-dropdown.scss";
import Target from "./Target";

const StatusDropdown = ({
  disabled = false,
  hiddenStatuses = [],
  isLoading = false,
  onItemClick,
  options,
  placeholder = null,
  selectedValue,
  shouldShowAllOptions = false,
  isClearable = false,
  onClear = noop,
  dataTestid = "status-dropdown",
}) => {
  const selectedOption = _findBy({ value: selectedValue }, options);

  return (
    <Dropdown
      {...{ disabled }}
      appendTo={() => document.body}
      strategy="fixed"
      zIndex={99999}
      customTarget={() => (
        <Target
          label={selectedValue}
          {...{
            ...selectedOption,
            dataTestid,
            isClearable,
            onClear,
            placeholder,
          }}
        />
      )}
    >
      {isLoading ? (
        <div className="flex w-full items-center justify-center py-8">
          <Spinner />
        </div>
      ) : (
        <Menu
          {...{ hiddenStatuses, onItemClick, options, shouldShowAllOptions }}
        />
      )}
    </Dropdown>
  );
};

StatusDropdown.Menu = Menu;

StatusDropdown.propTypes = {
  /**
   * This prop will decide whether the dropdown is disabled or not.
   */
  disabled: PropTypes.bool,
  /**
   * Statuses to be hidden when shouldShowAllOptions is false.
   */
  hiddenStatuses: PropTypes.array,
  /**
   * This prop will decide whether the dropdown is in loading state or not.
   */
  isLoading: PropTypes.bool,
  /**
   * Function to be called when a menu item is clicked.
   */
  onItemClick: PropTypes.func,
  /**
   * The items that should be shown in the dropdown.
   */
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
      color: PropTypes.string,
    })
  ),
  /**
   * Placeholder for the dropdown.
   */
  placeholder: PropTypes.string,
  /**
   * The selected value.
   */
  selectedValue: PropTypes.string,
  /**
   * This prop will decide whether all options should be shown or not.  If set to false, the items in hiddenStatuses will not be shown.
   */
  shouldShowAllOptions: PropTypes.bool,
  /**
   * This prop will decide whether the dropdown is clearable or not.
   */
  isClearable: PropTypes.bool,
  /**
   * Function to be called when the clear button is clicked.
   */
  onClear: PropTypes.func,
};

export default StatusDropdown;
